module.exports = __webpack_public_path__ + "static/media/nlr-logo-color-horizontal-png-v2.2b16ca5b.png";